import { useEffect, useRef, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { uploadBlob } from "../lib/media";
import AuthMedia from "./AuthMedia";
import { Button } from "./ui/button";
import { ImageIcon, Upload, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const CoverImageCard = ({ embedded = false }) => {
  const [cover, setCover] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    api.get("/profile").then((res) => setCover(res.data.cover_image)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const data = await uploadBlob(file, file.name);
      await api.put("/profile/cover", { media: data });
      setCover(data);
      toast.success("Copertina impostata");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.put("/profile/cover", { media: null });
      setCover(null);
      toast.success("Copertina rimossa");
    } finally {
      setBusy(false);
    }
  };

  if (loading) return null;

  return (
    <div className={embedded ? "" : "bg-white rounded-2xl border border-border p-6 mb-8"} data-testid="cover-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-[#EAF2ED] flex items-center justify-center shrink-0">
          <ImageIcon className="w-6 h-6 text-[#81B29A]" />
        </div>
        <div className="flex-1">
          <p className="font-serif text-lg">Foto di Copertina della Capsula</p>
          <p className="text-sm text-muted-foreground">Scegli un'immagine simbolo che accoglierà i tuoi cari all'apertura della Capsula del Tempo.</p>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={() => fileRef.current?.click()} disabled={busy} variant="outline" className="rounded-full border-border" data-testid="cover-upload-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Upload className="w-4 h-4 mr-2" />}
            {cover ? "Cambia" : "Scegli immagine"}
          </Button>
          {cover && (
            <Button onClick={remove} disabled={busy} variant="ghost" className="rounded-full text-destructive hover:bg-destructive/10" data-testid="cover-remove-btn">
              <Trash2 className="w-4 h-4" />
            </Button>
          )}
        </div>
      </div>
      {cover && (
        <div className="mt-4 rounded-xl overflow-hidden border border-border">
          <AuthMedia item={cover} className="w-full h-40 object-cover" />
        </div>
      )}
      <input ref={fileRef} type="file" accept="image/*" onChange={upload} className="hidden" data-testid="cover-file-input" />
    </div>
  );
};

export default CoverImageCard;
